// ====== General Error codes
export const GENERAL_SERVER_ERROR = 'GENERAL_SERVER_ERROR';

// ====== Reservation Error codes
export const RESERVATION_NOT_FOUND = 'RESERVATION_NOT_FOUND';

export type ErrorTypes = typeof RESERVATION_NOT_FOUND | typeof GENERAL_SERVER_ERROR;

